import {
  MarketingSection,
  SectionIntro,
  SectionKicker,
  SectionTitle,
} from "@/components/marketing/MarketingSection";
import { cn } from "@/lib/utils";

// Frames are capped at the card width so they can't spill out of narrow cards.
const FORMATS = [
  {
    name: "YouTube",
    ratio: "16:9",
    image: "youtube",
    alt: "Lyric video formatted for YouTube",
    card: "bg-[#F0EDFF]",
    frame: "aspect-video w-full max-w-[158px]",
  },
  {
    name: "Reels, TikTok & Shorts",
    ratio: "9:16",
    image: "vertical",
    alt: "Lyric video formatted for Reels, TikTok, and Shorts",
    card: "bg-[#FFF0F6]",
    frame: "aspect-[9/16] w-[min(154px*9/16,100%)]",
  },
  {
    name: "Square",
    ratio: "1:1",
    image: "square",
    alt: "Square lyric video format",
    card: "bg-[#EDF3FF]",
    frame: "aspect-square w-[min(126px,100%)]",
  },
  {
    name: "Classic",
    ratio: "4:3",
    image: "classic",
    alt: "Classic lyric video format",
    card: "bg-[#FFF1E8]",
    frame: "aspect-[4/3] w-[min(150px,100%)]",
  },
  {
    name: "Portrait",
    ratio: "3:4",
    image: "portrait",
    alt: "Portrait lyric video format",
    card: "bg-[#E9FBF8]",
    frame: "aspect-[3/4] w-[min(148px*3/4,100%)]",
  },
];

export default function LyricVideoFormats() {
  return (
    <MarketingSection className="bg-white">
      <SectionKicker>Export formats</SectionKicker>
      <SectionTitle>One lyric video. Five formats.</SectionTitle>
      <SectionIntro>
        Export your finished video in the sizes you need for YouTube, social
        media, and wherever your music goes.
      </SectionIntro>
      <div className="mt-[52px] grid grid-cols-5 gap-[18px] max-[680px]:grid-cols-2 max-[680px]:gap-[14px]">
        {FORMATS.map((format) => (
          <article
            key={format.image}
            className={cn(
              "min-w-0 rounded-[20px] border border-[rgba(35,46,93,0.1)] p-5 max-[680px]:p-4",
              format.card,
            )}
          >
            <div className="flex h-[178px] items-center justify-center max-[680px]:h-[170px]">
              <div
                className={cn(
                  "overflow-hidden rounded-[8px] border-2 border-[rgba(20,29,69,0.18)] bg-white/[0.62]",
                  format.frame,
                )}
              >
                <img
                  src={`/marketing/lyric-video/lyric-format-${format.image}.webp`}
                  alt={format.alt}
                  loading="lazy"
                  className="block size-full object-cover"
                />
              </div>
            </div>
            <div className="mt-4 flex min-h-[60px] flex-col items-start gap-[6px] font-figtree leading-[1.55] text-marketing-ink">
              <strong className="text-[17px] font-bold leading-[1.15]">
                {format.name}
              </strong>
              <span className="text-[14px] font-[850] text-blue-600">
                {format.ratio}
              </span>
            </div>
          </article>
        ))}
      </div>
    </MarketingSection>
  );
}
